import {
  HomeIcon,
  BellIcon,
  UserIcon,
  AwardIcon,
  GridIcon,
  FlagIcon,
  StarIcon,
  SmileIcon,
  BoxIcon,
  GiftIcon,
  VideoIcon,
  TvIcon,
  UsersIcon,
  DatabaseIcon,
  ImageIcon,
  AlertTriangleIcon,
  BarChartIcon,
  MenuIcon,
  FileIcon,
  ApertureIcon,
  LockIcon
} from "vue-feather-icons";

export default [
  { title: "Dashboard", route: "apps-dashboard", icon: HomeIcon, roles: ["super-admin", "admin", "member", "coordinator"] },
  { title: "Push Notifications", route: "apps-pushnotifications", icon: BellIcon, roles: ["super-admin", "admin"] },
  { title: "Talent Categories", route: "apps-categories", icon: AwardIcon, roles: ["super-admin", "admin", "member", "coordinator"] },
  { title: "Talent Sub Categories", route: "apps-sub-categories", icon: AwardIcon, roles: ["super-admin", "admin", "member", "coordinator"] },
  { title: "Manage Positions", route: "apps-pricemanagement", icon: GridIcon, roles: ["super-admin", "admin"] },
  { title: "Teams", route: "apps-font", icon: FlagIcon, roles: ["super-admin", "admin", "member", "coordinator"] },
  { title: "Stars", route: "apps-gift", icon: StarIcon, roles: ["super-admin", "admin"] },
  { title: "Talents", route: "apps-subcategories", icon: UserIcon, roles: ["super-admin", "admin", "member", "coordinator"] },
  { title: "Talent (Under 18)", route: "apps-banners", icon: SmileIcon, roles: ["super-admin", "admin", "member", "coordinator"] },
  { title: "Talent Scouts", route: "apps-regions", icon: UserIcon, roles: ["super-admin", "admin", "member", "coordinator"] },
  { title: "Packages", route: "apps-ads", icon: BoxIcon, roles: ["super-admin", "admin"] },
  { title: "Rewards", route: "apps-promocode", icon: GiftIcon, roles: ["super-admin", "admin"] },
  { title: "Reels Management", route: "apps-payout", icon: VideoIcon, roles: ["super-admin", "admin"] },
  { title: "News", route: "apps-vendor", icon: TvIcon, roles: ["super-admin", "admin"] },
  { title: "Advertisement", route: "apps-advert", icon: TvIcon, roles: ["super-admin", "admin"] },
  { title: "Geo Verse", route: "apps-myuser", icon: UsersIcon, roles: ["super-admin", "admin"] },
  { title: "Geo Nexus", route: "apps-requests", icon: DatabaseIcon, roles: ["super-admin", "admin"] },
  { title: "Posts", route: "pages-posts", icon: ImageIcon, roles: ["super-admin", "admin"] },
  { title: "Reports", route: "apps-reports", icon: AlertTriangleIcon, roles: ["super-admin", "admin"] },
  { title: "Analysis Reports", icon: BarChartIcon, roles: ["super-admin", "admin"], children: [
      { title: "User Following Report", route: "apps-followanalysis", roles: ["super-admin", "admin"] },
      { title: "Scout Reports", route: "apps-scoutanalysis", roles: ["super-admin", "admin"] },
      { title: "Talent Reports", route: "apps-talentanalysis", roles: ["super-admin", "admin"] }
    ]
  },
  { title: "Referrals", route: "apps-referrals", icon: MenuIcon, roles: ["super-admin", "admin"] },
  { title: "Terms & Conditions", route: "apps-terms", icon: FileIcon, roles: ["super-admin", "admin"] },
  { title: "Privacy Policy", route: "apps-privacy", icon: ApertureIcon, roles: ["super-admin", "admin"] },
  { title: "Change password", route: "auth-reset-password-v1", icon: LockIcon, roles: ["super-admin", "admin", "member", "coordinator"] }
];
